import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Navimumbaitoshirditaxifare() {



  const cardData = {
    keyword: " Navi Mumbai to Shirdi Taxi Fare  ",


"headingDescription": "Royal Route Cab offers reliable Navi Mumbai Airport to Shirdi cab service, providing safe, comfortable, and affordable pilgrimage travel for families, devotees, senior citizens, and group journeys. The distance between Navi Mumbai Airport and Shirdi is approximately 220–250 km, and the journey typically takes 5–6 hours via smooth highways like the Samruddhi Mahamarg. Our professional drivers ensure timely airport pickup, luggage assistance, and a stress-free travel experience with well-maintained vehicles. We offer flexible options including one-way drops, round trips, and customized Shirdi darshan packages. Our fleet includes air-conditioned sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is your trusted choice for Navi Mumbai Airport to Shirdi cab service.",

"topPlaces": [
  {
    "title": "Shri Sai Baba Samadhi Mandir",
    "description": "Shri Sai Baba Samadhi Mandir is the most sacred and visited temple in Shirdi, housing the samadhi of Sai Baba. Devotees from across India visit daily for darshan, aarti, and spiritual blessings. The temple complex manages large crowds efficiently with organized queues, VIP passes, and peaceful darshan arrangements, making it the main attraction for pilgrims arriving from Navi Mumbai Airport."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai Masjid is a highly revered place where Sai Baba spent most of his life. It contains sacred artifacts like the eternal dhuni (holy fire) and is believed to have healing spiritual energy. Visitors experience a deep sense of devotion and history as they explore this important religious site within the Shirdi temple complex."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is another significant site associated with Sai Baba where he used to sleep on alternate nights. The place is preserved as part of the pilgrimage circuit and holds strong historical and spiritual importance. Devotees visit Chavadi as part of the complete Shirdi darshan experience."
  },
  {
    "title": "Shani Shingnapur (Nearby Attraction)",
    "description": "Shani Shingnapur is a famous temple located around 70 km from Shirdi, dedicated to Lord Shani. The village is unique for its open-door homes and strong belief in divine protection. Many travelers combine Shirdi and Shani Shingnapur in a single cab itinerary for a complete spiritual journey."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a themed attraction showcasing the life and times of Sai Baba through recreated village settings, statues, and cultural displays. It helps visitors understand Sai Baba’s teachings in an immersive environment and is popular among families and tourists."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a peaceful garden maintained in memory of Sai Baba, where he used to water plants daily. The site includes a small shrine and a beautifully maintained garden space that offers a calm and devotional atmosphere for visitors."
  },
  {
    "title": "Wet n Joy Water Park",
    "description": "Wet n Joy Water Park is a popular recreational attraction near Shirdi, offering water rides, slides, and entertainment activities for families and groups. It is often visited by tourists after darshan for relaxation and leisure activities."
  },
  {
    "title": "Sai Teerth Theme Park",
    "description": "Sai Teerth Theme Park is India’s first devotional theme park dedicated to Sai Baba, featuring 3D shows, storytelling rides, and spiritual experiences. It combines technology and devotion, making it a unique attraction for pilgrims and tourists."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is the place where Sai Baba was first identified as a divine figure. It holds historical importance in his life story and is often included in pilgrimage tours for devotees seeking deeper spiritual understanding."
  },
  {
    "title": "Shirdi Market Area",
    "description": "The Shirdi market area is a bustling zone near the temple offering devotional items, souvenirs, prasad, clothing, and local food. It is a lively place where pilgrims shop after darshan and experience local culture and hospitality."
  }
],






services: [
  {
    name: "Mumbai to Shirdi Cab",
    description: "Mumbai to Shirdi cab service offers a comfortable and reliable journey for devotees visiting Sai Baba Temple. Ideal for families and pilgrimage trips, this service ensures smooth highway travel. Professional drivers and clean vehicles enhance comfort. It guarantees a peaceful and hassle-free journey."
  },
  {
    name: "Mumbai to Shirdi Taxi",
    description: "Mumbai to Shirdi taxi provides private and convenient travel with door-to-door pickup. This service is ideal for long-distance religious travel. Comfortable seating ensures a pleasant ride. It guarantees a smooth journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Fare",
    description: "Mumbai to Shirdi taxi fare is transparent and affordable based on vehicle type and trip duration. Customers receive clear pricing before booking. No hidden charges ensure trust. It helps in planning travel costs efficiently."
  },
  {
    name: "Mumbai to Shirdi Car Rental",
    description: "Mumbai to Shirdi car rental offers flexible vehicle options for personal and group travel. Customers can choose from sedan, SUV, and luxury vehicles. Comfortable interiors enhance travel experience. It ensures a convenient journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Service",
    description: "Mumbai to Shirdi taxi service ensures dependable transportation with experienced drivers and well-maintained vehicles. Ideal for pilgrimage and family trips. It guarantees a safe and comfortable journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Innova Fare",
    description: "Mumbai to Shirdi taxi Innova fare offers pricing details for spacious and premium travel. Innova is ideal for families and groups. Transparent fare ensures no hidden charges. It helps in selecting the right vehicle."
  },
  {
    name: "Mumbai to Shirdi Cab Service",
    description: "Mumbai to Shirdi cab service provides professional travel solutions with multiple vehicle options. This service is suitable for devotees and tourists. Clean vehicles and trained drivers ensure comfort. It ensures a smooth journey."
  },
  {
    name: "Mumbai Airport to Shirdi Taxi",
    description: "Mumbai airport to Shirdi taxi offers direct transfers from airport terminals to Shirdi. Ideal for travelers arriving by flight. Professional drivers ensure timely pickup. It guarantees a stress-free journey."
  },
  {
    name: "Mumbai to Shirdi Taxi Price",
    description: "Mumbai to Shirdi taxi price varies based on vehicle type and trip duration. Transparent pricing ensures clarity for customers. Budget and premium options are available. It helps in planning travel expenses."
  },
  {
    name: "Mumbai to Shirdi Cab Fare",
    description: "Mumbai to Shirdi cab fare is designed to be competitive and affordable. Pricing depends on route and vehicle type. Customers receive detailed fare information. It ensures cost-effective travel."
  },
  {
    name: "Book Taxi from Mumbai to Shirdi",
    description: "Book taxi from Mumbai to Shirdi with easy online booking and instant confirmation. Customers can select vehicle type, pickup time, and location. Transparent pricing ensures trust. It simplifies travel planning."
  },
  {
    name: "Innova from Mumbai to Shirdi",
    description: "Innova from Mumbai to Shirdi offers spacious and comfortable travel for families and groups. Premium seating and smooth ride quality enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Shirdi Cab Booking",
    description: "Mumbai to Shirdi cab booking allows customers to reserve rides easily with flexible options. Travelers can choose preferred vehicles and schedules. Instant confirmation ensures convenience. It simplifies travel planning."
  },
  {
    name: "Navi Mumbai to Shirdi Taxi Fare",
    description: "Navi Mumbai to Shirdi taxi fare is transparent and budget-friendly for intercity travel. Customers receive clear pricing before booking. No hidden charges ensure reliability. It helps in planning travel costs."
  },
  {
    name: "Navi Mumbai to Shirdi Cab Fare",
    description: "Navi Mumbai to Shirdi cab fare depends on vehicle type and trip duration. Affordable pricing ensures convenience for travelers. Clear cost details are provided. It ensures value for money."
  },
  {
    name: "Navi Mumbai to Shirdi Taxi Price",
    description: "Navi Mumbai to Shirdi taxi price is competitive and suitable for all types of travelers. Customers can choose from budget to premium options. Transparent pricing enhances trust. It ensures cost-effective travel."
  },
  {
    name: "Navi Mumbai to Shirdi Cab Price",
    description: "Navi Mumbai to Shirdi cab price varies based on vehicle selection and travel plan. Flexible options are available for different budgets. Clear pricing ensures no surprises. It helps in easy planning."
  },
  {
    name: "Taxi Fare from Navi Mumbai to Shirdi",
    description: "Taxi fare from Navi Mumbai to Shirdi offers complete pricing transparency for long-distance travel. Customers receive detailed fare breakdown before booking. It ensures a reliable and budget-friendly journey."
  }
],

tableData: [
  ["Mumbai to Shirdi Cab", "Mumbai to Shirdi Taxi"],
  ["Mumbai to Shirdi Taxi Fare", "Mumbai to Shirdi Car Rental"],
  ["Mumbai to Shirdi Taxi Service", "Mumbai to Shirdi Taxi Innova Fare"],
  ["Mumbai to Shirdi Cab Service", "Mumbai Airport to Shirdi Taxi"],
  ["Mumbai to Shirdi Taxi Price", "Mumbai to Shirdi Cab Fare"],
  ["Book Taxi from Mumbai to Shirdi", "Innova from Mumbai to Shirdi"],
  ["Mumbai to Shirdi Cab Booking", "Navi Mumbai to Shirdi Taxi Fare"],
  ["Navi Mumbai to Shirdi Cab Fare", "Navi Mumbai to Shirdi Taxi Price"],
  ["Navi Mumbai to Shirdi Cab Price", "Taxi Fare from Navi Mumbai to Shirdi"]
],


whychoose: [
  {
    WhyChooseheading: "Affordable Navi Mumbai to Shirdi Taxi Fare",
    WhyChoosedescription: "Royal Route Cabs offers budget-friendly taxi fare from Navi Mumbai to Shirdi, perfect for darshan trips, family travel, and weekend journeys."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "We provide clear fare details including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Comfortable & Smooth Travel Experience",
    WhyChoosedescription: "Enjoy a relaxed journey to Shirdi with well-maintained AC vehicles and comfortable seating."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai to Shirdi routes, ensuring safe driving and timely arrival."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Pricing",
    WhyChoosedescription: "Choose from one-way taxi fare or round-trip packages based on your travel plan and budget."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai to Shirdi taxi service operates 24/7 for early morning darshan or late-night travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Shirdi Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Navi Mumbai to Shirdi cab bookings due to reliable service and fair pricing."
  }
]

};

const faqData = [
  { question: "What is the taxi fare from Navi Mumbai to Shirdi?", answer: "Taxi fare starts from ₹3000 to ₹3500 for sedan and may go up depending on vehicle type and package." },
  { question: "What is the distance between Navi Mumbai and Shirdi?", answer: "The distance is approximately 220 to 250 km and takes around 4.5 to 6 hours." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Shirdi taxi service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "What is the SUV fare for this route?", answer: "SUV fares typically range from ₹4500 to ₹6000 depending on the vehicle and package." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide same-day return?", answer: "Yes, same-day return packages are available for Shirdi darshan trips." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and festive seasons." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Navi Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Patil",
    feedback: "The Navi Mumbai to Shirdi taxi service with Royal Route Cabs was very smooth and comfortable. The driver was punctual and the journey felt peaceful throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Seema Kulkarni",
    feedback: "Excellent experience traveling from Navi Mumbai to Shirdi. The cab was clean, the ride was calm, and the service felt reliable for our pilgrimage journey.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Shirdi Taxi Fare",
  "image": "https://www.royalroutecabs.com/assets/images/navi-mumbai-to-shirdi-taxi.jpg", // replace if needed
  "description": "Book Navi Mumbai to Shirdi taxi service with Royal Route Cabs for safe, comfortable, and reliable pilgrimage travel. Get transparent taxi fares for sedan, SUV, Innova, and Ertiga with 24x7 outstation cab service.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/navi-mumbai-to-shirdi-taxi-fare"
  }
};








  return (
    <div>

<Helmet>
  <title>Navi Mumbai to Shirdi Taxi Fare | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Shirdi taxi at best fare with Royal Route Cabs. Safe and affordable pilgrimage cab service with Innova, SUV, sedan, and 24x7 availability."
  />

  <meta
    name="keywords"
    content="navi mumbai to shirdi taxi fare, mumbai to shirdi cab, mumbai to shirdi taxi, mumbai to shirdi taxi fare, mumbai to shirdi car rental, mumbai to shirdi taxi service, mumbai to shirdi taxi innova fare, mumbai to shirdi cab service, mumbai airport to shirdi taxi, mumbai to shirdi taxi price, mumbai to shirdi cab fare, book taxi from mumbai to shirdi, innova from mumbai to shirdi, mumbai to shirdi cab booking, navi mumbai to shirdi taxi fare, navi mumbai to shirdi cab fare, navi mumbai to shirdi taxi price, navi mumbai to shirdi cab price, taxi fare from navi mumbai to shirdi, shirdi taxi fare from navi mumbai, cab charges navi mumbai to shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitoshirditaxifare;